var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSide2Landing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 631,
    viewBox: "0 0 63 631",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.013 240.5C-12.487 100.5 36.513 0.5 43.513 0H62.513V631C9.713 631 0.846333 587 3.013 565C8.17967 503.5 15.413 352.5 3.013 240.5Z",
    fill: "#0063A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSide2Landing);
export default __webpack_public_path__ + "static/media/side-2-landing.7e2d4dbd98e7c25984dbf247b308ce6a.svg";
export { ForwardRef as ReactComponent };